import { Currency } from "@redotech/money/currencies";
import { MetricDefinitionPartZodSchema } from "@redotech/redo-model/checkouts/metric-definition";
import * as z from "zod/v4";

export const getCheckoutOptimizationSummaryMetrics = {
  name: "getCheckoutOptimizationSummaryMetrics" as const,
  input: z.null(),
  output: z.object({
    annualizedCumulativeImpactToRevenuePerCheckoutFromAbTestsLastYear: z.object(
      {
        shopCurrency: z.enum(Currency),
        value: z.number().optional(),
        calculationUsed: z.array(MetricDefinitionPartZodSchema).optional(),
      },
    ),
    checkoutConversionRateOverLast30Days: z.number().optional(),
    averageShippingRevenuePerOrderLast30Days: z.object({
      shopCurrency: z.enum(Currency),
      value: z.number().optional(),
    }),
  }),
};
